(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoMixtoPIIRegenerarService', ReporteEvaluativoMixtoPIIRegenerarService);

    ReporteEvaluativoMixtoPIIRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoMixtoPIIRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteMixtoPII/:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo,:grupo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteMixtoPIIregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
